import { constRoute } from "@utils/route";
import { useNavigate } from "react-router-dom";

import style from "./style.module.scss";
import greenClimateFundImage from "@assets/pages/select-donor/green_climate_fund.png";
import globalEnvironmentFacilityImage from "@assets/pages/select-donor/global_environment_facility.png";
import adaptationFundImage from "@assets/pages/select-donor/adaptation_fund.png";
import gizImage from "@assets/pages/select-donor/giz.png";
import idbImage from "@assets/pages/select-donor/idb.jpg";
import theWorldBankImage from "@assets/pages/select-donor/the_world_bank.png";

import GoBack from "@components/common-components/go-back";

const SelectDonor = () => {
  const navigate = useNavigate();

  const btnCardsList = [
    {
      name: "Green Climate Fund",
      navigate: () => navigate(constRoute?.selectFunction),
      img: <img src={greenClimateFundImage} />,
      disabled: false,
      comingSoon: false,
    },
    {
      name: "Adaptation Fund",
      navigate: () => navigate(constRoute?.selectFunction),
      img: <img src={adaptationFundImage} />,
      disabled: true,
      comingSoon: true,
    },
    {
      name: "Inter-American Development Bank",
      navigate: () => navigate(constRoute?.selectFunction),
      img: <img style={{ maxHeight: "90px" }} src={idbImage} />,
      disabled: true,
      comingSoon: true,
    },
    {
      name: "Gesellschaft für Internationale Zusammenarbeit (GIZ)",
      navigate: () => navigate(constRoute?.selectFunction),
      img: <img style={{ maxHeight: "90px" }} src={gizImage} />,
      disabled: true,
      comingSoon: true,
    },
    {
      name: "Global Environment Facility",
      navigate: () => navigate(constRoute?.selectFunction),
      img: (
        <img
          style={{ maxHeight: "90px" }}
          src={globalEnvironmentFacilityImage}
        />
      ),
      disabled: true,
      comingSoon: true,
    },
    {
      name: "The World Bank",
      navigate: () => navigate(constRoute?.selectFunction),
      img: <img style={{ maxHeight: "90px" }} src={theWorldBankImage} />,
      disabled: true,
      comingSoon: true,
    },
  ];

  return (
    <div className={style.donorContainer}>
      <h2>Select a donor below</h2>

      <div className={style.donorContainerCardsContainer}>
        {btnCardsList.map((crd) => (
          <div
            key={crd.name}
            onClick={crd.disabled ? null : crd.navigate}
            className={crd.disabled ? style.disabled : null}
          >
            {crd.comingSoon && (
              <div className={style.comingSoon}>Coming Soon</div>
            )}
            {crd.img}
          </div>
        ))}
      </div>
      <div className={style.btnDiv}>
        <div className={style.twoBtnDiv}>
          <div className={style.goBackBtnDiv}>
            <GoBack onClick={constRoute?.home} className={style.goBtn} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectDonor;
